import React from "react";
import customerIcon from "../../Assets/Images/happy-customers.png";
import guidanceIcon from "../../Assets/Images/expert-guidance.png";
import fastIcon from "../../Assets/Images/faster-certification.png";

const BeneficialElements = () => {
  const cards = [
    {
      icon: customerIcon,
      title: "Happy Customers",
      desc: "Proudly trusted by clients worldwide for smooth, successful, and reliable ISO certification services worldwide."
    },
    {
      icon: guidanceIcon,
      title: "Expert Guidance",
      desc: "Comprehensive support from experienced ISO consultants at every stage, offering expert advice, personalised, and tailored guidance to ensure successful certification."
    },
    {
      icon: fastIcon,
      title: "Faster Certification Process",
      desc: "Streamlined steps save you time, minimise paperwork, and avoid delays — so you can focus on your business while we handle certification complexities."
    }
  ];

  return (
    <section className="beneficial-section">
   <div className="container beneficial-section">
        <div className="beneficial-left">
        <span className="badge">Beneficial</span>
        <h2 className="beneficial-left-h2">Beneficial <br/>Elements</h2>
        <h2 className="beneficial-heading">Beneficial Heading</h2>
        <p>
          ISO certification boosts credibility, builds trust, and drives growth.
        </p>
      </div>

      <div className="beneficial-right">
        {cards.map((card, index) => (
          <div className="beneficial-card" key={index}>
            <img src={card.icon} alt={card.title} />
            <h3>{card.title}</h3>
            <p>{card.desc}</p>
          </div>
        ))}
      </div>
   </div>
    </section>
  );
};

export default BeneficialElements;
